export default __webpack_public_path__ + "static/media/notification-music.6d9d4a3e.svg";